enum AddShapeMode {
    LABEL = "label",
    RECTANGLE = "rectangle",
    PILL = "pill",
    DIAMOND = "diamond",
    PLACEHOLDER = "placeholder",
    ANNOTATION = "annotation"
}

export default AddShapeMode;
